"use client";

import Context from "@/context/Context";
import Layout from "@/components/Header/Layout";
import ForgotPassword from "@/components/User/ForgotPassword";
import HomeChatSwitcher from "@/components/Common/HomeChatSwitcher";

const ForgotPasswordClient = () => (
  <Context>
    <Layout />
    <ForgotPassword />
    <HomeChatSwitcher />
  </Context>
);

export default ForgotPasswordClient;
